import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PerformanceComponent } from './components/performance-at-a-glance/performance.component';
import { PerformanceTransitionComponent } from './components/performance-transition/performance-transition.component';
import { PerformanceGoalTrackingComponent } from './components/performance-goal-tracking/performance-goal-tracking.component';
import { PerformanceInsightsKPIComponent } from './components/performance-insights-kpi/performance-insights-kpi.component';
import { PerformanceInsightsKPISparklineComponent } from './components/performance-insights-kpi-sparkline/performance-insights-kpi-sparkline.component';
import { PerformanceKpiComponent } from './components/performance-kpi/performance-kpi.component';
import { PerformanceReportsComponent } from './components/performance-reports/performance-reports.component';
import { PerformanceScorecardsComponent } from './components/performance-scorecards/performance-scorecards.component';
import { PerformanceUpgradeComponent } from './components/performance-upgrade/performance-upgrade.component';
import { PerformanceScorecardEmployeeTypeComponent } from './components/performance-scorecard-employee-type/performance-scorecard-employee-type.component';
import { PerformanceScorecardEntityComponent } from './components/performance-scorecard-entity/performance-scorecard-entity.component';
import { PerformanceScorecardThirdPartyComponent } from './components/performance-scorecard-third-party/performance-scorecard-third-party.component';
import { PerformanceInsightsComponent } from './components/performance-insights/performance-insights.component';
import { PerformanceProjectionsConfigComponent } from './components/performance-projections-config/performance-projections-config.component';
import { PerformanceInsightsKpiLOComponent } from './components/performance-insights-kpi-lo/performance-insights-kpi-lo.component';
import { AuthGuardService } from '../shared/services/auth-guard.service';
import { PerformanceInsightWeightedRankingsComponent } from './components/performance-insight-weighted-rankings/performance-insight-weighted-rankings.component';
import { PerformanceRankingsPositionComponent } from './components/performance-rankings-position/performance-rankings-position.component';
import { PerformanceBranchLeaderboardComponent } from './components/performance-branch-leaderboard/performance-branch-leaderboard.component';
import { PerformanceRankingsBranchComponent } from './components/performance-rankings-branch/performance-rankings-branch.component';
import { PerformanceInsightsMonthlyLoRankingsComponent } from './components/performance-insights-monthly-lo-rankings/performance-insights-monthly-lo-rankings.component';
import { PerformanceActualsVsProjectionsComponent } from './components/performance-actuals-vs-projections/performance-actuals-vs-projections.component';

const performanceRoutes: Routes = [
    { path: '', component: PerformanceTransitionComponent },
    {
        path: 'at-a-glance',
        component: PerformanceComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'goal-tracking',
        component: PerformanceGoalTrackingComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights',
        component: PerformanceInsightsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/kpi',
        component: PerformanceInsightsKPIComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'kpi',
        component: PerformanceKpiComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'reports',
        component: PerformanceReportsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards',
        component: PerformanceScorecardsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/lo',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/post-closer',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/ae',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/branch',
        component: PerformanceScorecardEntityComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/processor',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/loa',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/underwriter',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/closer',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/funder',
        component: PerformanceScorecardEmployeeTypeComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/lender',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/broker',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/buyer-agent',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/buyer-agency',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/settlement-agency',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/investor',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'scorecards/servicer',
        component: PerformanceScorecardThirdPartyComponent,
        canActivate: [AuthGuardService],
    },
    { path: 'upgrade', component: PerformanceUpgradeComponent },
    {
        path: 'projections-config',
        component: PerformanceProjectionsConfigComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/kpi-sparkline',
        component: PerformanceInsightsKPISparklineComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/kpi-employee',
        component: PerformanceInsightsKpiLOComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/weighted-rankings',
        component: PerformanceInsightWeightedRankingsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/performance-rankings-position',
        component: PerformanceRankingsPositionComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/branch-leaderboard',
        component: PerformanceBranchLeaderboardComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/performance-rankings-branch',
        component: PerformanceRankingsBranchComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/monthly-lo-rankings',
        component: PerformanceInsightsMonthlyLoRankingsComponent,
        canActivate: [AuthGuardService],
    },
    {
        path: 'insights/performance-actuals-vs-projections',
        component: PerformanceActualsVsProjectionsComponent,
        canActivate: [AuthGuardService],
    },
];

@NgModule({
    imports: [RouterModule.forChild(performanceRoutes)],
    exports: [RouterModule],
})
export class PerformanceRoutingModule {}
